import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchCurrentUser, logoutUser } from "../redux/slices/authSlice";
import HomePage from "../Pages/Home/HomePage";
import ProductPage from "../Pages/Product/ProductPage";
import Search from "../Pages/Search/Search";
import AdminLogin from "../Pages/Auth/AdminLogin";
import UserLogin from "../Pages/Auth/UserLogin";
import UserProfile from "../Pages/Auth/UserProfile";
import ProtectedRoute from "../Components/Common/ProtectedRoute";
import AboutUs from "../Pages/AdditionalPages/AboutUs";
import TermsOfUse from "../Pages/AdditionalPages/TermsOfUse";
import PrivacyPolicy from "../Pages/AdditionalPages/PrivacyPolicy";
import AffiliateDisclosure from "../Pages/AdditionalPages/AffiliateDisclosure";
import Dashboard from "../Pages/Dashboard/dashboard.jsx";
import ImageSearch from "../Pages/ImageSearch/ImageSearch";
import NewOnSaleProductsPage from "../Pages/NewOnSaleProducts/NewOnSaleProductsPage";
import ViewAllProductsPage from "../Pages/ViewAllProducts/ViewAllProductsPage";
import BrandsPage from "../Pages/Brands/BrandsPage";
import ViewBrandsOnSaleNew from "../Pages/Brands/ViewBrandsOnSaleNew";
import AssistantResults from "../Pages/AssistantResults/AssistantResults";
import AssistantChatPopup from "../Components/AssistantChat/AssistantChatPopup";
import { AssistantChatProvider } from "../Components/AssistantChat/AssistantChatContext";
import GlobalAssistantButton from "../Components/AssistantChat/GlobalAssistantButton";

const Router = () => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);

  useEffect(() => {
    if (token) {
      dispatch(fetchCurrentUser());
    }
  }, [dispatch, token]);

  useEffect(() => {
    const handleStorageChange = (e) => {
      // Native storage event gives e.key === "userToken", custom or null gives fallback check
      if (!e.key || e.key === "userToken") {
        const currentStoredToken = localStorage.getItem("userToken");
        if (!currentStoredToken) {
          dispatch(logoutUser());
        } else if (currentStoredToken !== token) {
          window.location.reload();
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [dispatch, token]);

  return (
    <BrowserRouter basename="/">
      <AssistantChatProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />
          {/* Admin Routes */}
          <Route path="/admin-login" element={<AdminLogin />} />

          {/* User Routes */}
          <Route path="/login" element={<UserLogin />} />
          <Route path="/profile" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />

          <Route path="/product" element={<ProductPage />} />
          <Route path="/search" element={<Search />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/affiliate-disclosure" element={<AffiliateDisclosure />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/image-search" element={<ImageSearch />} />
          <Route path="/new-arrivals/:brandParam" element={<NewOnSaleProductsPage type="new_arrivals" />} />
          <Route path="/on-sale/:brandParam" element={<NewOnSaleProductsPage type="on_sale" />} />
          <Route path="/view-all/:brandParam" element={<ViewAllProductsPage />} />
          <Route path="/brands" element={<BrandsPage />} />
          <Route path="/brands/new-arrivals" element={<ViewBrandsOnSaleNew />} />
          <Route path="/brands/on-sale" element={<ViewBrandsOnSaleNew />} />
          <Route path="/assistant-results" element={<ProtectedRoute><AssistantResults /></ProtectedRoute>} />
          <Route path="*" element={<HomePage />} />
        </Routes>
        <AssistantChatPopup />
        <GlobalAssistantButton />
      </AssistantChatProvider>
    </BrowserRouter>
  );
};

export default Router;
